export default "__VITE_ASSET__CKNe2rPl__"